// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Zi1h8","button":"styles_button__cuSuq"};